export default __webpack_public_path__ + "static/media/element_30.cf1ef924.jpg";